import { USER_ERROR,USER_SUCCESS,EDIT_USER,SHOW_USER,CREATE_USER,Create_Missing_Balance,edit_Missing_Balance } from './actionTypes';
import {getApi} from "../../services/httpService";

export const createUser = (user) => {
    return {
        type: CREATE_USER,
        payload: { user }
    }
}

export const showUser = (user_id) => {
    return {
        type: SHOW_USER,
        payload: { user_id }
    }
}

export const editUser = (user) => {
    return {
        type: EDIT_USER,
        payload: { user }
    }
}

export const createMissingBalance = (user) => {
    return {
        type: Create_Missing_Balance,
        payload: { user }
    }
}

export const editMissingBalance = (user) => {
    return {
        type: edit_Missing_Balance,
        payload: { user }
    }
}



export const userSuccess = (msg) => {
    console.log('msg',msg)
    return {
        type: USER_SUCCESS,
        payload: msg
    }
}


export function userShow(user_id){
    return getApi().get('user/'+user_id)
}

export function accountInfo(){
    return getApi().get('parkSettings/account/info')
}

export function parkingAccountInfo(){
    return getApi().get('print/list')
}


export function userList(params){
    return getApi().get('user/list',{
        params: params
    })
}

export function missingList(params){
    return getApi().get('report/missing/list',{
        params: params
    })
}

export function userSearchList(keyword,params){
    return getApi().get('user/search/'+keyword,{
        params: params
    })
}

export function userVehicleList(keyword,params){
    return getApi().get('userVehicleMapping/search/'+keyword,{
        params: params
    })
}



export const userError = (error) => {
    return {
        type: USER_ERROR,
        payload: error
    }
}
